import type Controller from '@ember/controller';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export interface RoutineRunModel {
	routineId: string;
	runId: string;
}

export default class RoutinesRunRoute extends Route {
	@service('ai-chat') declare aiChatService: Service.AIChat;

	override model(params: Record<string, unknown>): RoutineRunModel {
		const { routine_id: routineId, run_id: runId } = params as {
			routine_id: string;
			run_id: string;
		};

		return { routineId, runId };
	}

	override setupController(controller: Controller, model: RoutineRunModel): void {
		super.setupController(controller, model);

		// The row stands for the routine, not the run, so every run of it keeps the same row selected.
		this.aiChatService.applyUrlRoutine(model.routineId);
	}
}
